<template>
  <b-container>
    <b-row>
      <b-col class="h-20 logo" cols="2">
        <img src="@/assets/5895deb9cba9841eabab6099.png" width="50px" height="60px">
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="5"
        order-md="1"
        order="2"
        style="padding-left: 40px; padding-right: 40px;"
      >
        <b-col class="h-20 header-text">
          <div>
            <h2 class="text-left">Pick your team</h2>
          </div>
        </b-col>
        <b-col class="h-20 select-field">
          <label for="basic-url">Select a team from the list below.</label>
          <div>
            <b-form-select v-model="selected" v-on:change="show">
              <option v-for="item in options" :value="item">{{item.text}}</option>
            </b-form-select>
          </div>
        </b-col>

        <div class="btn-grp">
          <b-col class="float-left" cols="6">
            <b-button block v-on:click="$router.go(-1)">Prev</b-button>
          </b-col>

          <b-col class="float-right" cols="6">
            <b-button
              v-if="selected.value != 1"
              block
              v-on:click="onNext"
              :disabled="selected.value == 1"
            >Next</b-button>
          </b-col>
        </div>
      </b-col>

      <b-col cols="12" md="7" order-md="2" order="1">
        <div>
          <MyLottie :item="selected"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import MyLottie from "@/components/MyLottie.vue";
export default {
  name: "Question",
  components: {
    MyLottie
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      selected: {
        value: 1,
        segments: [74, 138]
      },
      options: [
        {
          value: 2,
          text: "New England Patriots",
          segments: [[138, 147], [148, 212], [212, 276]]
        },
        {
          value: 3,
          text: "Philadelphia Eagles",
          segments: [[138, 147], [148, 212], [212, 276]]
        }
      ],
      myValue: 0, // variable that is used to restart the slider
      index: 2, //  variable that tells us what question we are
      answers: [] // variable with the answers
    };
  },
  mounted() {
    console.log(this.$route);
    // we get the answers from localstorage
    if (localStorage.getItem("answers"))
      this.answers = JSON.parse(localStorage.getItem("answers"));
  },
  watch: {
    // we check if there are changes in the answers and we keep them locally
    answers: {
      handler() {
        console.log("Todos changed!");
        localStorage.setItem("answers", JSON.stringify(this.answers));
      },
      deep: true
    }
  },
  methods: {
    /**
     *
     *  it is used to change the question to the next
     */
    show() {
      console.log(this.selected);
      localStorage.setItem("item", JSON.stringify(this.selected));
      this.index = this.selected;
    },

    onNext(next) {
      console.log("next");
      this.index++; // we increase the index
      if (this.index === 11) {
        // if it is the last question, show the results layer
        this.$router.push({ name: "result" });
      } else {
        // but it shows the next question
        this.$router.push({
          name: "team",
          params: { num: this.selected.value }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-text {
  margin-top: 20%;
  margin-bottom: 30px;
  padding-left: 30px;
}

@media only screen and (max-width: 600px) {
  .header-text {
    margin-top: 0;
  }
}
@media only screen and (min-width: 767px) {
  div#myLottie {
    position: relative;
    bottom: 0;
  }
}
.intro-text {
  padding-left: 30px;
}
div#myLottie {
  position: relative;
  bottom: 80px;
}
label {
  font-size: 18px;
  font-weight: normal;
  text-align: left;
}
.alto {
  height: 50px;
  width: 50px;
}
.select-field {
  margin-top: 10%;
  margin-bottom: 30px;
  padding-left: 30px;
}
.btn-grp {
  margin-left: 10px;
}
button.btn.btn-secondary {
  background-color: #004986;
  border-radius: 15px;
}
button.btn.btn-secondary:hover {
  background-color: #004986c7;
  cursor: pointer;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  div#myLottie {
    position: relative;
    bottom: 0;
  }
  .header-text {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0px;
  }
  h2 {
    text-align: center !important;
  }
  label {
    font-size: 18px;
    font-weight: normal;
    margin-left: 0;
    padding-left: 0;
  }
  .intro-text {
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  button.btn.btn-secondary {
    background-color: #004986;
  }
  button.btn.btn-secondary:hover {
    background-color: #004986c7;
    cursor: pointer;
  }
  .select-field {
    margin-top: 0;
    margin-bottom: 40px;
    padding-left: 30px;
  }
  .logo {
    padding-left: 33px;
  }
}
</style>
